import React, { createContext, useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './ModalProvider.module.scss'; // eslint-disable-line no-unused-vars
import useLocalize from '../hooks/use-localize';

export const ModalContext = createContext();

const ModalProvider = ({ children }) => {
  const { localize } = useLocalize();
  const dialogRef = useRef(null);
  const [content, setContent] = useState('');

  useEffect(() => {
    if (content !== '') {
      dialogRef.current?.showModal();
    }
  }, [content]);

  const showModal = useCallback((content) => {
    setContent(content);
  }, []);

  const handleOnClose = useCallback(() => {
    setContent('');
  }, []);

  return (
    <ModalContext.Provider value={showModal}>
      {children}
      <dialog ref={dialogRef} onClose={handleOnClose}>
        <form method='dialog'>
          <div>{content}</div>
          <button>{localize('modal.close')}</button>
        </form>
      </dialog>
    </ModalContext.Provider>
  );
};

ModalProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default ModalProvider;
